type ShortcutKey = 'account' | 'userData' | 'userCompanies' | 'invoices' | 'payments' | 'settings' | 'warehouses' | 'help'

export const availableShortcuts: ShortcutKey[] = ['account', 'userData', 'userCompanies', 'invoices'/* , 'payments' */, 'settings', 'warehouses', 'help']

export const getIcon = (key: ShortcutKey) => {
  switch (key) {
    case 'account':
    case 'userData': return 'user'
    case 'userCompanies': return 'company'
    case 'warehouses': return 'mag-details'
    case 'invoices': return 'invoices'
    default: return key
  }
}

export const getPath = (key: ShortcutKey) => {
  switch (key) {
    case 'userData': return '/account/basic'
    case 'userCompanies': return '/account/company'
    case 'invoices': return '/account/invoices'
    case 'payments': return '/account/payments'
    case 'settings': return '/account/settings'
    default: return `/${key}`
  }
}